import { render, staticRenderFns } from "./InitiativeList.vue?vue&type=template&id=12f167f5&scoped=true"
import script from "./InitiativeList.vue?vue&type=script&lang=js"
export * from "./InitiativeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f167f5",
  null
  
)

export default component.exports